import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid, {
  IMdaeDataGridColumnProps,
  IMdaeDataGridProps,
} from "../../../common_components/common_widgets/data-grid";
import { getDataGridActionEllipsisComponent } from "../../../common_components/common_widgets/data-grid-action-ellipsis";
import { cloneDeep, first, isEmpty, isEqual } from "lodash";
import "./index.scss";
import {
  BULK_UPDATE_CASE_DETAIL_LIST_DATA,
  SET_EA_CASE_LIST_DATA,
  SET_INTERNAL_AUDIT_CASE_LIST,
  SET_IS_INCOMPLETE_TASK_COUNT_CLICK,
  SET_MARK_AS_SEEN_CASEIDS,
  SET_MARK_AS_UNSEEN_CASEIDS,
  SET_VIEW_COMPONENT_LINE_ITEMS,
  TOGGLE_CASE_LIST_DETAIL_ACTION_POPOVER,
  TOGGLE_GROUP_BY_VIEW_SWITCH,
  UPDATE_CASE_DETAIL_LIST_DATA,
} from "./reducers/case-list-reducer";
import { IColumnProps, MasterDetail } from "devextreme-react/data-grid";
import CaseBillingHistoryList from "./case-billing-history-list";
import $ from "jquery";
import MdaeButton from "../../../common_components/common_widgets/button";
import BulkUpdatePopup from "../../../common_components/bulk-update-popup";
import {
  EXECUTE_BULK_UPDATE,
  TOGGLE_BULK_UPDATE_POPUP,
  UPDATE_BULK_UPDATE_ROW_USING_KEY,
} from "../../../common_components/bulk-update-popup/reducers/bulk-update-popup-reducer";
import {
  BULK_UPDATE_CONFIG_NAMES,
  BULK_UPDATE_WARNINGS,
  getDisplayNameFromProperty,
} from "../../../common_components/bulk-update-popup/bulk-update-configuration";
import { BULK_UPDATE_EA_CASES } from "./services/bulk-update-ea-cases";
import {
  FG_AUDIT_A_CASE,
  FG_MANUAL_AUDIT_CREATION,
  hasAnyFeatureGroupAccess,
  hasWorkflowAccess,
  hasAnyInternalAuditWorkFlowAccess,
} from "../../../common_components/user-permissions-helper";
import { HOSPITAL_WORKFLOW } from "../../../common_components/user-permissions-helper";
import { PROFESSIONAL_WORKFLOW } from "../../../common_components/user-permissions-helper";
import { FG_EXTERNAL_AUDIT_CREATION } from "../../../common_components/user-permissions-helper";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
  TOGGLE_NOTIFY_POPUP,
} from "../../../common_components/mdae-common-reducer";
import { callOperation } from "async-ops";
import { DELETE_EXTERNAL_AUDIT_CASE } from "./services/delete-external-audit-case";
import { GET_AUDIT } from "../services/get-audit";
import { NOTIFY_POPUP_TYPES } from "../../../common_components/common_widgets/notify-popup";
import CopyText from "../../../common_components/common_widgets/copy-text";
import {
  convertDate,
  convertDateFormat,
  getMaxDate,
} from "../../../utils/dateUtils";
import { GET_INTERNAL_AUDIT_CASE_LIST } from "./services/get-internal-audit-case-list";
import { SET_CURRENT_USER_ACTION_MODE } from "./reducers/case-list-reducer";
import { GET_EA_CASE_DETAIL_LIST } from "../services/get-ea-case-detail-list";
import {
  SET_AUDIT_ROUND_DATA,
  SET_EA_CASES_LIST,
  SET_ESMD_SUBMISSION_LIST,
  SET_REFRESH_AUDIT_SUMMARY_DATA,
} from "../reducers/external-audit-reducer";

import {
  SET_ESMD_SELECTED_TAB_INDEX,
  SET_SELECTED_ESMD_SUBMISSION_ITEM,
} from "../../../common_components/case-details/esMd-dashboard/reducers/esmd-submission-reducer";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { GET_ESMD_SUBMISSION_BY_AUDIT_ID } from "../services/get-esmd-submission-by-audit-id";
import {
  advanceToNextRoundErrorMsgBytype,
  CASE_LIST_TYPES,
  errorMessagesByType,
} from "./constants";
import MdaeDateBox from "../../../common_components/common_widgets/date-box";
import { ValidationGroup, Validator } from "devextreme-react";
import { RequiredRule } from "devextreme-react/validator";
import MdaeSwitch from "../../../common_components/common_widgets/switch";
import dxDataGrid from "devextreme/ui/data_grid";
import { toggleCaseDetailPopup } from "../case-detail/case-detail-common-functions";
import { SET_AUDIT_PROPERTIES_DATA } from "../reducers/audit-properties-reducer";
import { SAVE_NEW_BILLING_DATA_AS_SEEN } from "./services/save-new-billing-data-as-seen";
import MdaeCheckBox from "../../../common_components/common_widgets/check-box";
import { ACTIVATE_EACASE_NEW_BILLING_INDICATOR } from "./services/activate-eacase-new-billing-indicator";
import { CaseDetailPopover } from "../../../common_components/case-details/ea-case-list";
import { AUDIT_LIST_TYPE } from "../../emdr-inbox/constant";
import UserTasks from "../case-list-page/userTaskList";
import AddUserTaskPopup from "../../../common_components/user-task-list/add-user-task";
import { toggleUserTaskPopup } from "../../../common_components/user-task-list/component";
import CustomStore from "devextreme/data/custom_store";
import { GET_CASE_LIST_FOR_PAGE } from "../case-list-page/services/get-cases-for-list-page";
import ReassignProcessManagerPopup, { toggleReassignProcessManagerPopup } from "./bulk-reassign-process-manager-popup";
let isCompletedRoundGroupsCollapsed = false;

export const runBillingOperation  = (
  operation: string,
  eaCaseIds: number[],
  updates: Record<string, any>
) => async (dispatch: any) => {
  if (!eaCaseIds || eaCaseIds.length === 0) return;

  dispatch({ type: SHOW_LOADER });
  try {
    await callOperation(operation, eaCaseIds);
    dispatch({
      type: BULK_UPDATE_CASE_DETAIL_LIST_DATA,
      data: { eaCaseIds, updates },
    });
  } finally {
    dispatch({ type: HIDE_LOADER });
  }
};
export const createBillingHandler = ({
  e,
  operation,
  updates,
}: {
  e: any;
  operation: string;
  updates: Record<string, any>;
}) => {
  return () => (dispatch: any) => {
    const eaCaseIds = [e.data.eaCaseId];
    dispatch(runBillingOperation(operation, eaCaseIds, updates));
  };
};
export const refreshCaseListFromDb = (
  dispatch,
  auditId,
  updateRoundData = false
) => {
  return new Promise<void>((resolve, reject) => {
    dispatch({ type: SHOW_LOADER });
    callOperation(GET_AUDIT, { auditId: auditId })
      .then(function(response) {
        let eaCaseListData = [];
        eaCaseListData.push(response.auditPropertiesData.externalAuditCaseData);
        eaCaseListData[0].caseList =
          eaCaseListData[0].caseList == null ? [] : eaCaseListData[0].caseList;
        dispatch({
          type: SET_EA_CASE_LIST_DATA,
          data: {
            eaCaseListData: eaCaseListData,
            showCaseChangesInformation: false,
          },
        });
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
              statusId: response.auditPropertiesData.statusId,
            },
          },
        });
        isCompletedRoundGroupsCollapsed = false;
        dispatch({
          type: SET_EA_CASES_LIST,
          data: {
            auditCasesList:
              response.auditPropertiesData.auditCasesList == null
                ? []
                : response.auditPropertiesData.auditCasesList,
          },
        });
        if (
          updateRoundData &&
          response.auditPropertiesData?.eaRounds?.length > 0
        )
          dispatch({
            type: SET_AUDIT_ROUND_DATA,
            data: {
              eaAuditRounds: response.auditPropertiesData.eaRounds,
            },
          });
        resolve();
        dispatch({ type: HIDE_LOADER });
      })
      .catch(() => {
        dispatch({ type: HIDE_LOADER });
      });
  });
};
export const deleteExternalAuditCase = (auditCaseData, dispatch, type: string, refreshCasesList = null) => {
  return new Promise<void>((resolve, reject) => {
    dispatch({ type: SHOW_LOADER });
    callOperation(DELETE_EXTERNAL_AUDIT_CASE, auditCaseData)
      .then(function(response) {
        if (response.isDeleted) {
          if(type === CASE_LIST_TYPES.FROM_AUDIT){
            refreshCaseListFromDb(dispatch, auditCaseData?.eaAuditId);
            dispatch({
              type: SET_REFRESH_AUDIT_SUMMARY_DATA,
              data: true,
            });
          }else{
            refreshCasesList()
          }
        }
        resolve();
      })
      .finally(() => {
        dispatch({ type: HIDE_LOADER });
      });
  });
};
export const refreshEaCaseListTab = (dispatch, auditId) => {
  const eaCaseListData = [];
  callOperation(GET_EA_CASE_DETAIL_LIST, auditId).then((response) => {
    eaCaseListData.push(response.externalAuditCaseData);
    dispatch({
      type: SET_EA_CASE_LIST_DATA,
      data: {
        eaCaseListData: eaCaseListData,
        showCaseChangesInformation: false,
      },
    });
  });
};

/*  errorObject is a object like
    {
      "<error number>": "<comma seperated account numbers>",
      "<error number>": "<comma seperated account numbers>"
       ...
    }
 */
const WarningUIForAdvaningCase = ({ errorObject, validationGroup }) => {
  const dispatch = useDispatch();
  return (
    <ValidationGroup ref={validationGroup}>
      {Object.keys(errorObject).map((errorObjectKey) => {
        switch (errorObjectKey) {
          case "1":
            return (
              <div>
                <div className="top-margin">
                  {advanceToNextRoundErrorMsgBytype[errorObjectKey]}
                </div>
                <MdaeDateBox
                  id="dtSubmissionDateFromBulkUpdate"
                  mdaeDateBoxTitle=""
                  onValueChanged={(e) => {
                    if (e.event)
                      dispatch({
                        type: UPDATE_BULK_UPDATE_ROW_USING_KEY,
                        data: {
                          fieldName: getDisplayNameFromProperty(
                            "caseRoundSubmissionDate"
                          ),
                          fieldValue: e.value,
                          savePropertyName: "caseRoundSubmissionDate",
                        },
                      });
                  }}
                >
                  <Validator>
                    <RequiredRule message="Submission Date is required" />
                  </Validator>
                </MdaeDateBox>
              </div>
            );
          case "4":
            return (
              <div>
                <div className="top-margin">
                  {advanceToNextRoundErrorMsgBytype[errorObjectKey]}
                </div>
                <MdaeDateBox
                  id="dtDeterminationDateFromBulkUpdate"
                  mdaeDateBoxTitle=""
                  onValueChanged={(e) => {
                    if (e.event)
                      dispatch({
                        type: UPDATE_BULK_UPDATE_ROW_USING_KEY,
                        data: {
                          fieldName: getDisplayNameFromProperty(
                            "caseRoundDaterminationDate"
                          ),
                          fieldValue: e.value,
                          savePropertyName: "caseRoundDaterminationDate",
                        },
                      });
                  }}
                >
                  <Validator>
                    <RequiredRule message="Determination Date is required" />
                  </Validator>
                </MdaeDateBox>
              </div>
            );
          default:
            return (
              <div style={{ marginTop: "15px" }}>
                <div>{advanceToNextRoundErrorMsgBytype[errorObjectKey]}</div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "10px",
                  }}
                >
                  <div style={{ marginRight: "10px" }}>
                    {errorObject[errorObjectKey]?.join("; ")}
                  </div>
                  <CopyText
                    className="copy-text copy-action-icon"
                    textToCopy={errorObject[errorObjectKey]?.join("; ")}
                  />
                </div>
              </div>
            );
        }
      })}
    </ValidationGroup>
  );
};

const BulkUpdateErrorMessageUI = ({
  bulkUpdateResponse,
  validationGroup,
}: any) => {
  return bulkUpdateResponse.errorMessageType == 6 ? (
    <WarningUIForAdvaningCase
      errorObject={bulkUpdateResponse.advanceToNewRoundErrorList}
      validationGroup={validationGroup}
    />
  ) : (
    <div>
      <div>{errorMessagesByType[bulkUpdateResponse.errorMessageType]}</div>
      <div
        style={{
          display: "flex",
          marginTop: "20px",
        }}
      >
        <div style={{ marginRight: "10px" }}>
          {bulkUpdateResponse.errorMessageType != 2 &&
            bulkUpdateResponse.caseAccountIds}
        </div>
        {bulkUpdateResponse.errorMessageType != 2 && (
          <CopyText
            className="copy-text copy-action-icon"
            textToCopy={bulkUpdateResponse.caseAccountIds}
          />
        )}
      </div>
    </div>
  );
};

const ToolbarSearchInfoIcon = () => {
  return (
    <span
      style={{
        marginLeft: 12,
        alignSelf: "center",
        marginRight: 12,
      }}
      className="search-button application-section-primary-color"
      title={
        "Searches the following case fields: Patient Name, MRN, Original Account Number, Account Number, Payer Claim ID, Audit Title, Payer Remit #."
      }
    >
      <i className="img-circle fa fa-info-circle audit-info-circle"></i>
    </span>
  );
};

const USER_ACTION_MODE = Object.freeze({
  BULK_UPDATE: "BULK_UPDATE",
  ADD_TO_INTERNAL_AUDIT: "ADD_TO_INTERNAL_AUDIT",
});

const getGroupRowDataRecursively = (data) => {
  const firstKey: any = first(data);
  if (firstKey?.key) {
    return getGroupRowDataRecursively(firstKey?.items);
  } else {
    return data;
  }
};
interface ICaseListDetailProps {
  data: any;
  history: any;
  isExternalAuditReadOnly: boolean;
  type?: string;
  caseListType?: string;
  isCaseListPage?:boolean;
  refreshCasesList?: () => void;
}
const CaseListDetail: React.FC<ICaseListDetailProps> = (props) => {
  const validationGroup = useRef(null);
  const [caseDetailDataGridInstance, setCaseDetailDataGridInstance] = useState<
    dxDataGrid
  >(null);
  const getCurrentSelectedRowData: any = () => {
    return first(caseDetailDataGridInstance?.getSelectedRowsData());
  };
  const [selectedCasesList, setSelectedCasesList] = useState([]);
  const dispatch = useDispatch();

  const auditPropertiesData = useSelector(
    (state: any) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
  const isCaseDetailPopupVisible = useSelector(
    (state: any) => state["caseDetailReducer"].isCaseDetailPopupVisible
  );

  const eaCaseListData = useSelector(
    (state) => state["caseListReducer"].eaCaseListData,
    isEqual
  );
  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const hasAuditCreateAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_EXTERNAL_AUDIT_CREATION], currentUser),
    [currentUser]
  );
  const hasHospitalWorkFlowEnabled = useMemo(
    () => hasWorkflowAccess([HOSPITAL_WORKFLOW], currentUser),
    [currentUser]
  );
  const hasProfessionalWorkFlowEnabled = useMemo(
    () => hasWorkflowAccess([PROFESSIONAL_WORKFLOW], currentUser),
    [currentUser]
  );

  const hasAuditViewAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_AUDIT_A_CASE], currentUser),
    [currentUser]
  );
  const isDocumentManagementEnabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentManagementEnabled,
    isEqual
  );
  const eaAuditRounds = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds,
    isEqual
  );
  const internalAuditCaseList = useSelector(
    (state) => state["caseListReducer"].internalAuditCaseList,
    isEqual
  );
  const hasManualAuditCreateAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_MANUAL_AUDIT_CREATION], currentUser),
    [currentUser]
  );
  const hasInternalWorkFlowAccess = useMemo(
    () => hasAnyInternalAuditWorkFlowAccess(currentUser),
    [currentUser]
  );
  const currentUserActionMode = useSelector(
    (state) => state["caseListReducer"].currentUserActionMode,
    isEqual
  );
  const hasExternalAuditCases = useSelector(
    (state) =>
      state["caseListReducer"].eaCaseListData[0]?.caseList?.filter(
        (x) => x.eaCaseId > 0
      ).length > 0,
    isEqual
  );
  const esmdSubmissionListForAudit = useSelector(
    (state) => state["externalAuditReducer"].esmdSubmissionListForAudit,
    isEqual
  );
  const isShowGroupByRoundView = useSelector(
    (state) => state["caseListReducer"].isShowGroupByRoundView,
    isEqual
  );
  const caseIdsMarkedAsSeen = useSelector(
    (state) => state["caseListReducer"].caseIdsMarkedAsSeen,
    isEqual
  );
  const sessionValue = window.sessionStorage.getItem(
    auditPropertiesData?.eaAuditId + "PAW"
  );
  const getSessionStorageValueViewCmpnt =
    sessionValue && sessionValue !== "undefined"
      ? JSON.parse(sessionValue)
      : false;

  const showchkbxViewCmpntFromReducer = useSelector(
    (state) => state["caseListReducer"].isShowChkbxViewCmpnt
  );
  const isShowChkbxViewCmpnt = getSessionStorageValueViewCmpnt
    ? getSessionStorageValueViewCmpnt
    : showchkbxViewCmpntFromReducer;

  const isNewBillingDataPresentForAudit = useSelector(
    (state: any) => state["caseListReducer"].isNewBillingDataPresentForAudit,
    isEqual
  );
  const isReassignProcessManagerPopupVisible = useSelector(
    (state) => state["caseListReducer"].isReassignProcessManagerPopupVisible,
    isEqual
  );
  useEffect(() => {
    const sessionValue = window.sessionStorage.getItem(
      auditPropertiesData?.eaAuditId + "PAW"
    );
    const sessionStorageValue =
      sessionValue && sessionValue !== "undefined"
        ? JSON.parse(sessionValue)
        : false;

    if (sessionStorageValue !== showchkbxViewCmpntFromReducer) {
      dispatch({
        type: SET_VIEW_COMPONENT_LINE_ITEMS,
        data: { isShowChkbxViewCmpnt: sessionValue },
      });
    }
  }, [auditPropertiesData?.eaAuditId, showchkbxViewCmpntFromReducer]);

  const toggleCaseListDetailActionPopover = (
    isVisible,
    target,
    otherConfig = null
  ) => {
    dispatch({
      type: TOGGLE_CASE_LIST_DETAIL_ACTION_POPOVER,
      data: {
        caseListDetailDataGidActionPopoverTarget:
          ".case-detail-datagrid-cell-" + otherConfig?.currentRowData?.eaCaseId,
        [`isCaseDetailPopoverVisible${props?.data?.data?.eaAuditId}`]: isVisible,
      },
    });
  };

  const caseListRowPrepared = (e) => {
    if (e.rowType == "data") {
      $(e.cellElement).addClass("clickable-cell-cursor");
    }
    if (currentUserActionMode == USER_ACTION_MODE.BULK_UPDATE) {
      if (
        e.rowType === "data" &&
        e.column.command === "select" &&
        e.data.statusType?.toLowerCase() === "completed"
      ) {
        $(e.cellElement).off();
        $(e.cellElement)
          .find("*")
          .remove();
      }
    }
    if (e.rowType === "data" && e.column.command === "expand") {
      if (
        props.isCaseListPage ? !e.data.inCompleteTaskCount : (e.data.caseBillingHistoryList &&
          e.data.caseBillingHistoryList.length == 0) ||
        e.data.caseBillingHistoryList == undefined ||
        e.data.historyCount == 0
      ) {
        $(e.cellElement).removeClass("dx-datagrid-expand");
        $(e.cellElement).empty();
      }
      if (e.data?.newRecordInd) {
        for (let billingHistory in e.data?.caseBillingHistoryList) {
          if (
            e.data?.caseBillingHistoryList[billingHistory]?.isOnAudit == true &&
            e.data?.caseBillingHistoryList[billingHistory]?.newRecordInd == true
          ) {
            $(e.cellElement)
              .children()
              .attr("style", "color: blue");
            $(e.cellElement)
              .children()
              .prop("title", "New billing data received");
            break;
          }
        }
      }
    }
    if (currentUserActionMode == USER_ACTION_MODE.ADD_TO_INTERNAL_AUDIT) {
      if (e.rowType === "header" && e.column.command === "select") {
        if (internalAuditCaseList.length == eaCaseListData[0].caseList.length) {
          $(e.cellElement)
            .find(".dx-select-checkbox")
            .attr("style", "display: none");
          $(e.cellElement).attr("style", "pointer-events: none");
        }
      }

      if (e.rowType === "data" && e.column.command === "select") {
        if (
          internalAuditCaseList?.indexOf(e.data.caseId) > -1 ||
          e.data.eaCaseId == 0
        ) {
          $(e.cellElement)
            .find(".dx-select-checkbox")
            .attr("style", "display: none");
          $(e.cellElement).attr("style", "pointer-events: none");
        }
        if (
          (e.data.claimType.toLowerCase() == "hospital" &&
            !hasHospitalWorkFlowEnabled) ||
          (e.data.claimType.toLowerCase() == "professional" &&
            !hasProfessionalWorkFlowEnabled)
        ) {
          $(e.cellElement)
            .find(".dx-select-checkbox")
            .attr("style", "display: none");
          $(e.cellElement).attr("style", "pointer-events: none");
        }
      }
    }

    if (e.rowType === "data" && e.columnIndex === 2) {
      $(e.cellElement).addClass(
        "case-detail-datagrid-cell-" + e.data?.eaCaseId
      );
    }
    if (
      e.rowType === "data" &&
      e.column.dataField?.toLowerCase() === "roundsubmissiondeadline" &&
      convertDateFormat(e.data.roundSubmissionDeadline) <
        convertDateFormat(new Date()) &&
      !e.data.actualSubmissionDate
    ) {
      $(e.cellElement).addClass("red-round-submission-deadline-date");
    }
    if (
      e.rowType === "group" &&
      e.text != "" &&
      e.column?.dataField?.toLowerCase() === "roundsequenceno"
    ) {
      var rowItems = e.row.isExpanded
        ? e.row.data?.items
        : e.row.data?.collapsedItems;
      rowItems = getGroupRowDataRecursively(rowItems);
      var roundDeterminationDateList = rowItems
        ?.filter((x) => x.roundDeterminationDate != null)
        .map((x) => x.roundDeterminationDate);
      const firstRowItem: any = cloneDeep(first(rowItems));
      if (firstRowItem) {
        if (rowItems.find((x) => !x.caseFinalOutcome))
          firstRowItem.roundDeterminationDate = null;
        else
          firstRowItem.roundDeterminationDate = getMaxDate(
            roundDeterminationDateList
          );
        var roundFinalOutcomeDateList = rowItems
          ?.filter(
            (x) => x.finalOutcomeId != null && x.caseFinalOutcomeDate != null
          )
          .map((x) => x.caseFinalOutcomeDate);
        firstRowItem.caseFinalOutcomeDate = getMaxDate(
          roundFinalOutcomeDateList
        );

        $(e.cellElement).html(
          "<div>" +
            `${
              firstRowItem.eaProcessTemplateRoundName == null
                ? `Round `
                : `${firstRowItem.roundSequenceNo}: ${firstRowItem.eaProcessTemplateRoundName}`
            }` +
            `${
              firstRowItem.eaProcessTemplateRoundName == null
                ? firstRowItem.roundSequenceNo
                : ""
            } - ${firstRowItem.roundRequesterOrganizationName}` +
            `${
              firstRowItem.roundDeterminationDate == null ||
              firstRowItem.caseFinalOutcome == null
                ? ` In-Progress `
                : ``
            }` +
            `<span title="Earliest date that a case was transitioned into this round">` +
            ` (${convertDate(firstRowItem.roundLevelStartDate)}* - ` +
            `</span>` +
            `${
              firstRowItem.caseFinalOutcomeDate != null
                ? `<span title="Latest date that a case final outcome was assigned in the round"}>` +
                  `${convertDate(firstRowItem.caseFinalOutcomeDate)}*)` +
                  `</span>`
                : `)`
            }` +
            "</div>"
        );
      }
    }
  };
  const hideConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  };
  const handleHeaderClick = () => {
    if (!eaCaseListData || eaCaseListData.length === 0) return;

    const caseList = eaCaseListData[0].caseList || [];
    if (isNewBillingDataPresentForAudit) {
      const headerConfig = renderHeaderIcon();
      if (!headerConfig?.id) return;

      if (headerConfig.id === "MarkAsRead") {
        const eaCaseIdsToMarkSeen = caseList
          .filter(
            (item) =>
              item.newRecordInd === true && item.isNewBillingDataSeen !== true
          )
          .map((item) => item.eaCaseId);

        if (eaCaseIdsToMarkSeen.length > 0) {
          dispatch(
            runBillingOperation(
              SAVE_NEW_BILLING_DATA_AS_SEEN,
              eaCaseIdsToMarkSeen,
              { newRecordInd: false, isNewBillingDataSeen: true }
            )
          );
          return;
        }
      }
        else if (headerConfig.id === "MarkAsUnread") {
        const eaCaseIdsToReactivate = caseList
          .filter(
            (item) =>
              item.newRecordInd === false && item.isNewBillingDataSeen === true
          )
          .map((item) => item.eaCaseId);

        if (eaCaseIdsToReactivate.length > 0) {
          dispatch(
            runBillingOperation(
              ACTIVATE_EACASE_NEW_BILLING_INDICATOR,
              eaCaseIdsToReactivate,
              { newRecordInd: true, isNewBillingDataSeen: false }
            )
          );
        }
      }
    }
  };
  const renderHeaderIcon = () => {
    const isForAudit = props.caseListType === "FROM_AUDIT";
    const caseList = eaCaseListData[0]?.caseList || [];

    const isAnyCaseWithNewRecordInd = caseList.some(
      (item) => item.newRecordInd === true && item.isNewBillingDataSeen !== true
    );
    const isNewBillingDataReadForAudit = caseList.some(
      (item) =>
        item.newRecordInd === false && item.isNewBillingDataSeen !== false
    );

    if (isForAudit && isAnyCaseWithNewRecordInd) {
      return {
        iconClass: "fa fa-exclamation-triangle",
        color: "orange",
        title: "Mark all new billing data as seen",
        id :'MarkAsRead'
      };
    }
    if (
      isForAudit &&
      isNewBillingDataReadForAudit &&
      isNewBillingDataPresentForAudit
    ) {
      return {
        iconClass: "fa fa-check-circle",
        color: "green",
        title: "Mark all new billing data as  un-seen",
        id:'MarkAsUnread',
        fontSize: "15px"
      };
    }
    return { iconClass: null };
  };
  const showConfirmationPopup = (message, type) => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: () => {
          deleteExternalAuditCase(getCurrentSelectedRowData(), dispatch, type, props.refreshCasesList).then(
            () => {
              hideConfirmationPopup();
              dispatch({
                type: SET_REFRESH_AUDIT_SUMMARY_DATA,
                data: true,
              });
            }
          );
          if (
            eaAuditRounds[0]?.rqstrRecordSubmissionMethod?.toLowerCase() ==
              "esmd" ||
            esmdSubmissionListForAudit?.length > 0
          ) {
            callOperation(GET_ESMD_SUBMISSION_BY_AUDIT_ID, {
              auditId: auditPropertiesData?.eaAuditId,
            }).then((response) => {
              dispatch({
                type: SET_ESMD_SUBMISSION_LIST,
                data: {
                  esmdSubmissionListForAudit: Array.isArray(response)
                    ? response
                    : [],
                },
              });
            });
          }
        },
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        contentHtml: message,
        onDecline: hideConfirmationPopup,
      },
    });
  };
  let queryParameterEaCaseId = 0;
  let isEsmdNotification = false;
  let selectedEsmddocumentuploadId = 0;
  let myCases = false;
  const currentUrlSearchParams = new URLSearchParams(
    window.location.href.split("?")[1]
  );
  for (let parameterPair of currentUrlSearchParams.entries() as any) {
    if (
      parameterPair.length > 0 &&
      parameterPair[0] &&
      parameterPair[0].toLowerCase() === "isesmdnotification"
    ) {
      isEsmdNotification = parameterPair[1]?.toLowerCase() === "true";
    }
    if (
      parameterPair.length > 0 &&
      parameterPair[0] &&
      parameterPair[0].toLowerCase() === "eacaseid"
    ) {
      queryParameterEaCaseId = parseInt(parameterPair[1]);
    }
    if (
      parameterPair.length > 0 &&
      parameterPair[0] &&
      parameterPair[0].toLowerCase() === "esmddocumentuploadid"
    ) {
      selectedEsmddocumentuploadId = parseInt(parameterPair[1]);
    }
    if (
      parameterPair.length > 0 &&
      parameterPair[0] &&
      parameterPair[0].toLowerCase() === "mycases"
    ) {
      myCases = parameterPair[1]?.toLowerCase() === "true";
    }
  }
  const onCaseListDetailDataGridContentReady = (e) => {
    const openEsmdSubmissionTrackingTab = (eaCaseId) => {
      if (eaCaseId && eaCaseId > 0 && e.component.getDataSource()?.items()?.length > 0) {
        e.component.byKey(eaCaseId).then((data) => {
          toggleCaseDetailPopup(dispatch, true, "Audit Case Details", data, 5);
          dispatch({
            type: SET_ESMD_SELECTED_TAB_INDEX,
            data: {
              esmdSelectedTabIndex: 1,
              isTabChangedProgrammatically: true,
            },
          });
          dispatch({
            type: SET_SELECTED_ESMD_SUBMISSION_ITEM,
            data: selectedEsmddocumentuploadId,
          });
          if (queryParams.has("isesmdnotification")) {
            queryParams.delete("isesmdnotification");
            props.history.replace({
              search: queryParams.toString(),
            });
          }
        });
      }
    };
    const openCaseDataTab = (eaCaseId) => {
      if (eaCaseId && eaCaseId > 0 && e.component.getDataSource()?.items()?.length > 0) {
        e.component.byKey(eaCaseId).then((data) => {
          toggleCaseDetailPopup(dispatch, true, "Audit Case Details", data, 0);
        });
        if (queryParams.has("eacaseid")) {
          queryParams.delete("eacaseid");
          props.history.replace({
            search: queryParams.toString(),
          });
        }
      }
    };
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has("isesmdnotification") || queryParams.has("esmddocumentuploadid")) {
      openEsmdSubmissionTrackingTab(queryParameterEaCaseId);
    } else if (queryParams.has("eacaseid")) {
      openCaseDataTab(queryParameterEaCaseId);
    }
    e.component.beginUpdate();
    if (isShowGroupByRoundView && !props?.isCaseListPage) {
      e.component.columnOption("roundSequenceNo", "groupIndex", 0);
      e.component.columnOption("roundSequenceNo", "sortOrder", "desc");
    } else e.component.columnOption("roundSequenceNo", "groupIndex", null);
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
    if (!isCompletedRoundGroupsCollapsed && e.component.getDataSource()) {
      const dataSource = e.component.getDataSource().store()._array;
      var roundWithCasesHaveCompletedStatus = dataSource
        .filter((x) => x.caseStatusCd?.toLowerCase() == "completed")
        .map((x) => x.roundSequenceNo)
        .filter(onlyUnique);
      var roundWithoutCasesHaveCompletedStatus = dataSource
        .filter((x) => x.caseStatusCd?.toLowerCase() != "completed")
        .map((x) => x.roundSequenceNo)
        .filter(onlyUnique);
      roundWithCasesHaveCompletedStatus.forEach((element) => {
        if (
          e.component.isRowExpanded([element]) &&
          !roundWithoutCasesHaveCompletedStatus.find((x) => x == element)
        ) {
          e.component.collapseRow([element]);
          isCompletedRoundGroupsCollapsed = true;
        }
      });
    }
    e.component.endUpdate();
  };
  const headerBillingDataIndicator = useCallback(
    (container) => {
      container.innerHTML = "";

      const { iconClass, color, title, fontSize } = renderHeaderIcon();

      if (iconClass) {
        const icon = document.createElement("i");
        icon.className = iconClass;
        icon.style.color = color;
        icon.style.cursor = "pointer";
        icon.title = title;
        icon.style.fontSize =
          typeof fontSize === "number" ? `${fontSize}px` : fontSize;

        icon.addEventListener("click", () => handleHeaderClick(), { once: true });

        container.append(icon);
      }
    },
    [renderHeaderIcon, handleHeaderClick]
  );
  const eaCaseNewBillingIndicator=useCallback((e)=>{
    if (e.data?.newRecordInd) {
      return (
        <div title="New billing data received">
          <i
            className="fa fa-exclamation-triangle"
            style={{ color: "orange" }}
            onClick={() => {
              dispatch({ type: SHOW_LOADER });
              callOperation(SAVE_NEW_BILLING_DATA_AS_SEEN, [e?.data?.eaCaseId]).then(
                () => {
                  props.isCaseListPage ? dispatch({
                    type: SET_MARK_AS_SEEN_CASEIDS,
                    data: {
                      eaCaseId: e.data?.eaCaseId,
                    },
                  }):dispatch({
                    type: UPDATE_CASE_DETAIL_LIST_DATA,
                    data: {
                      eaCaseId: e.data?.eaCaseId,
                      newRecordInd: false,
                      isNewBillingDataSeen: true,
                    },
                  });

                }
              );
              dispatch({ type: HIDE_LOADER });
            }}
          ></i>
        </div>
      );
    } else if (e.data?.isNewBillingDataSeen || (props.isCaseListPage && caseIdsMarkedAsSeen.includes(e.data?.eaCaseId))) {
      return (
        <div>
          <i
            className="fa fa-check-circle"
            style={{ color: "green", fontSize: "15px" }}
            onClick={() => {
              dispatch({ type: SHOW_LOADER });
              callOperation(ACTIVATE_EACASE_NEW_BILLING_INDICATOR, [e?.data?.eaCaseId]).then(
                () => {
                  props.isCaseListPage ? dispatch({
                    type: SET_MARK_AS_UNSEEN_CASEIDS,
                    data: {
                      eaCaseId: e.data?.eaCaseId,
                    },
                  }):dispatch({
                    type: UPDATE_CASE_DETAIL_LIST_DATA,
                    data: {
                      eaCaseId: e.data?.eaCaseId,
                      newRecordInd: true,
                      isNewBillingDataSeen: false,
                    },
                  });
                }
              );
              dispatch({ type: HIDE_LOADER });
            }}
          ></i>
        </div>
      );
    }
  },[caseIdsMarkedAsSeen,props.isCaseListPage]);
  const headerRangeFilterCount = useSelector(
    (state: any) => state["caseListReducer"].headerRangeFilterCount
  );
  const dataSource = useMemo(
    () =>
      new CustomStore({
        key: "eaCaseId",
        load: async function(loadOptions) {
          try {
            const result = await callOperation(GET_CASE_LIST_FOR_PAGE, {
              loadOptionsViewModel: loadOptions,
              headerRangeFilterCount,
              filterByProcessManager: myCases,
            });
            if (result.groupedData) return { data: result.groupedData };
            else return result;
          } catch (error) {
            return {
              data: [],
              totalCount: 0,
            };
          }
        },
      }),
    [headerRangeFilterCount, window.location.search]
  );

  const caseListDetailDataGridOptions = useMemo(() => {
    isCompletedRoundGroupsCollapsed = false;
    return getCaseListDetailDataGridOptions(
      toggleCaseListDetailActionPopover,
      props.caseListType === CASE_LIST_TYPES.FROM_CASE_LIST_PAGE
        ? dataSource
        : eaCaseListData[0]?.caseList,
      caseListRowPrepared,
      auditPropertiesData?.eaAuditId,
      setCaseDetailDataGridInstance,
      dispatch,
      hasAuditViewAccess,
      currentUserActionMode,
      hasHospitalWorkFlowEnabled,
      hasProfessionalWorkFlowEnabled,
      eaAuditRounds,
      onCaseListDetailDataGridContentReady,
      toggleCaseDetailPopup,
      eaCaseNewBillingIndicator,
      props?.isCaseListPage,
      props?.caseListType,
      headerBillingDataIndicator,
      myCases
    );
  }, [
    eaCaseListData[0]?.caseList,
    internalAuditCaseList,
    currentUserActionMode,
    onCaseListDetailDataGridContentReady,
  ]);



  const showBulkUpdateWarnings = (warningsDataObject: any[]) => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        height: "auto",
        autoHeight: true,
        title: "Warning",
        width: 500,
        visible: true,
        confirmShown: true,
        confirmLabel: "OK",
        declineShown: true,
        contentHtml: () => {
          return (
            <>
              {Object.keys(warningsDataObject).map((warningKey) =>
                warningsDataObject[warningKey] ? (
                  <div style={{ marginTop: "15px" }}>
                    {warningKey ===
                    BULK_UPDATE_WARNINGS.REMANING_DOLLARS_IN_REVIEW ? (
                      <div>
                        {`The case data indicates that there are still dollars in
                            review. Do you want to add a final outcome without a complete
                            financial impact?`}
                      </div>
                    ) : (
                      <div>
                        {`The following case(s) already have data in the
                        ${getDisplayNameFromProperty(warningKey)} field.
                        Do you want to replace the existing data?`}
                      </div>
                    )}

                    <div
                      style={{
                        display: "flex",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ marginRight: "10px" }}>
                        {warningsDataObject[warningKey]}
                      </div>
                      <CopyText
                        className="copy-text copy-action-icon"
                        textToCopy={warningsDataObject[warningKey]}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )
              )}
            </>
          );
        },
        onConfirm: () => {
          hideConfirmationPopup();
          dispatch({
            type: EXECUTE_BULK_UPDATE,
            data: { executeBulkUpdate: true },
          });
        },
        onDecline: hideConfirmationPopup,
      },
    });
  };
  const bulkEditCasesSaveHandler = (
    bulkEditSelectedData,
    checkForWarnings = true,
    ignoreNoAdditionalRoundWarning = false
  ) => {
    return new Promise<any>((resolve) => {
      if (bulkEditSelectedData?.refundCompletedDate)
        bulkEditSelectedData.refundCompletedDate = convertDateFormat(
          bulkEditSelectedData.refundCompletedDate
        );
      if (bulkEditSelectedData?.refundSubmittedDate)
        bulkEditSelectedData.refundSubmittedDate = convertDateFormat(
          bulkEditSelectedData.refundSubmittedDate
        );
      if (bulkEditSelectedData?.caseRoundDaterminationDate)
        bulkEditSelectedData.caseRoundDaterminationDate = convertDateFormat(
          bulkEditSelectedData.caseRoundDaterminationDate
        );
      if (bulkEditSelectedData?.caseRoundSubmissionDate)
        bulkEditSelectedData.caseRoundSubmissionDate = convertDateFormat(
          bulkEditSelectedData.caseRoundSubmissionDate
        );
        const caseTargetRationaleValue = bulkEditSelectedData.caseTargetRationaleValue?.toString();
        if (caseTargetRationaleValue?.endsWith(",")) {
          bulkEditSelectedData.caseTargetRationaleValue = caseTargetRationaleValue.slice(0, -1);
        } else {
          bulkEditSelectedData.caseTargetRationaleValue = caseTargetRationaleValue;
        }
      dispatch({ type: SHOW_LOADER });
      callOperation(BULK_UPDATE_EA_CASES, {
        ...bulkEditSelectedData,
        eaCaseIdList: selectedCasesList,
        eaAuditId: auditPropertiesData?.eaAuditId,
        checkForWarnings,
        ignoreNoAdditionalRoundWarning,
      }).then((response) => {
        if (response.isExistingDataPresent) {
          showBulkUpdateWarnings(response.warningsDataObject);
          dispatch({ type: HIDE_LOADER });
          resolve(false);
          return;
        }
        refreshCaseListFromDb(dispatch, auditPropertiesData?.eaAuditId).then(
          () => {
            dispatch({ type: HIDE_LOADER });
          }
        );
        dispatch({
          type: SET_REFRESH_AUDIT_SUMMARY_DATA,
          data: true,
        });

        if (response && response.errorMessageType) {
          dispatch({
            type: TOGGLE_CONFIRMATION_POPUP,
            data: {
              height: "auto",
              autoHeight: true,
              title: "Warning",
              width: 500,
              visible: true,
              confirmShown: true,
              confirmLabel: "OK",
              declineShown: true,
              contentHtml: () => {
                return (
                  <BulkUpdateErrorMessageUI
                    bulkUpdateResponse={{ ...response }}
                    validationGroup={validationGroup}
                  />
                );
              },
              onConfirm: () => {
                let result = null;
                if (validationGroup?.current) {
                  result = validationGroup?.current.instance.validate();
                } else {
                  hideConfirmationPopup();
                  return;
                }
                if (result && result.isValid) {
                  if (
                    response.errorMessageType == 6 &&
                    (response.advanceToNewRoundErrorList["1"] ||
                      response.advanceToNewRoundErrorList["4"] ||
                      (response.advanceToNewRoundErrorList["5"] &&
                        !response.advanceToNewRoundErrorList["2"]))
                  ) {
                    dispatch({
                      type: EXECUTE_BULK_UPDATE,
                      data: {
                        executeBulkUpdate: true,
                        ignoreNoAdditionalRoundWarning: true,
                      },
                    });
                  }
                  hideConfirmationPopup();
                }
              },
              onDecline: hideConfirmationPopup,
            },
          });
          resolve({ isResetPopup: false });
        }
        resolve({ isClosePopup: true });
      });
    }).catch(() => {
      dispatch({ type: HIDE_LOADER });
    });
  };
  const toggleCaseDetailDataGridSelection = (_currentUserActionMode = "") => {
    const selectionObject = {
      allowSelectAll: true,
      mode: "multiple",
      selectAllMode: "allPages",
      showCheckBoxesMode: "always",
    };
    const currentSelectionMode = caseDetailDataGridInstance?.option(
      "selection.mode"
    );
    if ((currentSelectionMode as any)?.toLowerCase() === "none") {
      dispatch({
        type: SET_CURRENT_USER_ACTION_MODE,
        currentUserActionMode: _currentUserActionMode,
      });
      caseDetailDataGridInstance.option("selection", selectionObject as any);
      caseDetailDataGridInstance.option("columns[1].visible", false);
    } else {
      dispatch({
        type: SET_CURRENT_USER_ACTION_MODE,
        currentUserActionMode: "",
      });
      caseDetailDataGridInstance.option("selection.mode", "none");
      caseDetailDataGridInstance.option("columns[1].visible", true);
    }
  };
  const onReassignProcessManagerClick = useCallback(() => {
    const currentSelectionMode = caseDetailDataGridInstance?.option(
      "selection.mode"
    );

    if (
      (currentSelectionMode as string)?.toLowerCase() === "multiple" &&
      caseDetailDataGridInstance?.option("selectedRowKeys")?.length > 0
    ) {
      const selectedKeys =
        caseDetailDataGridInstance?.option("selectedRowKeys");

      setSelectedCasesList(selectedKeys);

      const selectedData =
        caseDetailDataGridInstance.getSelectedRowsData();

      const uniqueGroupIds = Array.from(
        new Set(selectedData.map((row) => row.auditGroupId))
      );

      toggleReassignProcessManagerPopup(
        true,
        uniqueGroupIds,
        dispatch
      );

      toggleCaseDetailDataGridSelection();
    } else {
      toggleCaseDetailDataGridSelection(
        USER_ACTION_MODE.BULK_UPDATE
      );
    }
  }, [
    caseDetailDataGridInstance,
    dispatch,
    setSelectedCasesList,
    toggleCaseDetailDataGridSelection,
  ]);

  const renderToolbarButtonTemplate = () => {
    return (
      <div style={{ display: "flex" }}>
         <MdaeButton
            id={"btnBulkReassignTask"}
            role={"dxButton"}
            icon="dx-icon fas fa-paper-plane application-section-primary-color"
            className="data-grid-toolbar-button"
            visible={!!props.isCaseListPage}
            text={""}
            elementAttr={{
              title: "Reassign Case Process Manager",
            }}
            onClick={onReassignProcessManagerClick}
          ></MdaeButton>
        {hasAuditViewAccess && (
          <MdaeButton
            role={"dxButton"}
            stylingMode={"text"}
            id={"btnBulkEditCases"}
            elementAttr={{ title: "Bulk Update" }}
            onContentReady={(e) => {
              $(e.component.element()).css("margin-right", "0px");
              $(e.component.element())
                .find(".dx-button-content")
                .css("padding", "0px");
            }}
            visible={props.caseListType === CASE_LIST_TYPES.FROM_AUDIT}
            disabled={
              currentUserActionMode ===
                USER_ACTION_MODE.ADD_TO_INTERNAL_AUDIT ||
              props?.isExternalAuditReadOnly
            }
            onClick={() => {
              const currentSelectionMode = caseDetailDataGridInstance?.option(
                "selection.mode"
              );
              if (
                (currentSelectionMode as string)?.toLowerCase() ===
                  "multiple" &&
                caseDetailDataGridInstance?.option("selectedRowKeys")?.length >
                  0
              ) {
                setSelectedCasesList(
                  caseDetailDataGridInstance?.option("selectedRowKeys")
                );
                dispatch({
                  type: TOGGLE_BULK_UPDATE_POPUP,
                  data: {
                    isBulkUpdatePopupVisible: true,
                    currentBulkUpdateConfigurationName:
                      BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE,
                  },
                });
                toggleCaseDetailDataGridSelection();
              } else {
                toggleCaseDetailDataGridSelection(USER_ACTION_MODE.BULK_UPDATE);
              }
            }}
          >
            <i className={"dx-icon bulk-update-icon"}></i>
          </MdaeButton>
        )}
        {hasManualAuditCreateAccess &&
          hasExternalAuditCases &&
          hasInternalWorkFlowAccess &&
          props.type !== AUDIT_LIST_TYPE.CASE_LIST && (
            <MdaeButton
              id={"btnAddEaCasesToInternalAudit"}
              role={"dxButton"}
              stylingMode="text"
              visible={props.caseListType === CASE_LIST_TYPES.FROM_AUDIT}
              elementAttr={{
                title: "Add to Internal Audit",
              }}
              disabled={currentUserActionMode === USER_ACTION_MODE.BULK_UPDATE}
              onClick={() => {
                const currentSelectionMode = caseDetailDataGridInstance?.option(
                  "selection.mode"
                );
                if (
                  (currentSelectionMode as string)?.toLowerCase() === "multiple"
                ) {
                  const selectedRowsData = caseDetailDataGridInstance.getSelectedRowsData();
                  let caseListRecords = [];
                  selectedRowsData.map((item) => {
                    if (internalAuditCaseList.indexOf(item.caseId) == -1) {
                      caseListRecords.push(item);
                    }
                  });
                  if (caseListRecords.length > 0) {
                    let caseList = [];
                    caseListRecords.map((item) => {
                      var row =
                        caseList.length > 0 &&
                        caseList.find(
                          (uniqueItem) =>
                            uniqueItem.patientAcctNo === item.patientAcctNo
                        );
                      if (row === undefined || caseList.length == 0)
                        caseList.push({
                          patientAcctNo: item.patientAcctNo,
                          caseType: item.auditCaseEntryTypeCd,
                          eaCaseId: item.eaCaseId,
                          mdauditCaseId: item.caseId,
                          caseDetailId: item.caseDetailId,
                        });
                    });

                    let today =
                      "(" + convertDateFormat(new Date(), "MM/DD/YYYY") + ")";
                    sessionStorage.setItem("PayerCaseListForAddToInternalAudit", JSON.stringify(caseList));
                    let auditTitle = "";
                    auditTitle += auditPropertiesData?.title + " - ";
                    if (!isEmpty(auditPropertiesData?.referenceId)) {
                      auditTitle += auditPropertiesData?.referenceId + " ";
                    }
                    auditTitle += today;
                    sessionStorage.setItem("AuditTitle", auditTitle);
                    let serviceFrom = convertDateFormat(
                      auditPropertiesData?.serviceFromDate,
                      "MM/DD/YYYY"
                    );
                    let serviceTo = convertDateFormat(
                      auditPropertiesData.serviceToDate,
                      "MM/DD/YYYY"
                    );
                    let auditGroupId = auditPropertiesData.auditGroupId;
                    let eaAuditId = auditPropertiesData.eaAuditId;
                    let createUrl =
                      "/audit/newaudit/?hasServiceDates=false&ServiceFrom=" +
                      serviceFrom +
                      "&ServiceTo=" +
                      serviceTo +
                      "&AuditGroupId=" +
                      auditGroupId +
                      "&UserId=" +
                      currentUser.userId +
                      "&EaAuditId=" +
                      eaAuditId +
                      "&ExternalAudit=true";
                    window.open(createUrl, "_blank");
                  }
                  toggleCaseDetailDataGridSelection();
                } else {
                  dispatch({ type: SHOW_LOADER });
                  callOperation(
                    GET_INTERNAL_AUDIT_CASE_LIST,
                    auditPropertiesData.eaAuditId
                  ).then((response) => {
                    dispatch({
                      type: SET_INTERNAL_AUDIT_CASE_LIST,
                      data: response?.map((x) => x.caseId),
                    });

                    dispatch({ type: HIDE_LOADER });
                    if (response.length < eaCaseListData[0].caseList.length) {
                      toggleCaseDetailDataGridSelection(
                        USER_ACTION_MODE.ADD_TO_INTERNAL_AUDIT
                      );
                    } else {
                      response = response.filter(
                        (x) =>
                          eaCaseListData[0]?.caseList?.filter(
                            (y) => y.caseId === x.caseId
                          ).length
                      );
                      response.forEach((element) => {
                        element.internalAuditUrl =
                          "/audit/index?auditId=" + element.auditId;
                      });
                      dispatch({
                        type: TOGGLE_NOTIFY_POPUP,
                        data: {
                          visible: true,
                          contentHtml: () => {
                            return (
                              <div>
                                <div style={{ display: "block" }}>
                                  All of the selected cases are already included
                                  in internal audits. Below is a list of the
                                  audits:
                                </div>
                                <div>
                                  <ul>
                                    {response.map((x) => (
                                      <li>
                                        <div style={{ display: "flex" }}>
                                          <div style={{ marginRight: "10px" }}>
                                            {x.caseId}:
                                          </div>
                                          <div>
                                            <a
                                              target="_blank"
                                              href={x.internalAuditUrl}
                                            >
                                              {x.auditId} - {x.title}
                                            </a>
                                          </div>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            );
                          },
                          notifyPopupType: NOTIFY_POPUP_TYPES.ALERT,
                          closeButtonText: "OK",
                          width: 550,
                          height: "auto",
                        },
                      });
                    }
                  });
                }
              }}
            >
              <i className={"dx-icon lines-check-icon"}></i>
            </MdaeButton>
          )}
      </div>
    );
  };
  return (
    <div>
      <CaseDetailPopover
        toggleCaseListDetailActionPopover={toggleCaseListDetailActionPopover}
        data={props.data}
        getCurrentSelectedRowData={getCurrentSelectedRowData}
        type={AUDIT_LIST_TYPE.CASE_LIST}
        caseListType={props.caseListType}
        refreshCasesList={props.refreshCasesList}
      />
      <div>
        <div className={"chbx-view-cmpnt-group-by-round-container"}>
          <div className="view-componenet-checkbox">
            <MdaeCheckBox
              defaultValue={false}
              id="showChbxViewCmpnt"
              text={"View Component Line Items"}
              value={isShowChkbxViewCmpnt}
              onValueChanged={(e) => {
                const newValue = e?.value;
                window.sessionStorage.setItem(
                  auditPropertiesData?.eaAuditId + "PAW",
                  newValue?.toString()
                );
                dispatch({
                  type: SET_VIEW_COMPONENT_LINE_ITEMS,
                  data: { isShowChkbxViewCmpnt: newValue },
                });
              }}
              visible={
                auditPropertiesData?.claimTypeCd?.toUpperCase() == "I" ||
                (auditPropertiesData?.claimTypeCd?.toUpperCase() == "A" &&
                  eaCaseListData[0]?.caseList.some(
                    (x) => x.claimTypeCd?.toUpperCase() == "I"
                  ))
              }
            />
          </div>
         {!props.isCaseListPage && ( <div className={"group-by-round-switch-container"}>
            <div className={"group-by-round-switch-label"}>Group By Round:</div>
            <div className={"group-by-round-switch"}>
              <MdaeSwitch
                value={isShowGroupByRoundView}
                onValueChanged={(e) => {
                  if (e.event)
                    dispatch({
                      type: TOGGLE_GROUP_BY_VIEW_SWITCH,
                      data: {
                        isShowGroupByRoundView: e.value,
                      },
                    });
                  caseDetailDataGridInstance.beginUpdate();
                  if (e.value) {
                    caseDetailDataGridInstance.columnOption(
                      "roundSequenceNo",
                      "groupIndex",
                      0
                    );
                    caseDetailDataGridInstance.columnOption(
                      "roundSequenceNo",
                      "sortOrder",
                      "desc"
                    );
                  } else {
                    caseDetailDataGridInstance.columnOption(
                      "roundSequenceNo",
                      "groupIndex",
                      null
                    );
                  }
                  caseDetailDataGridInstance.endUpdate();
                }}
              ></MdaeSwitch>
            </div>
          </div>)}
        </div>
      </div>
      <div>
        <MdaeDataGrid
          {...caseListDetailDataGridOptions}
          mdaeDataGridCustomButtons={renderToolbarButtonTemplate}
          mdaeDataGridCustomButtonsEnd={
            props.caseListType === CASE_LIST_TYPES.FROM_CASE_LIST_PAGE
              ? ToolbarSearchInfoIcon
              : null
          }
        >
          <MasterDetail enabled={true} component={props?.isCaseListPage ? UserTasks :CaseBillingHistoryList} />
        </MdaeDataGrid>
      </div>
      {!isCaseDetailPopupVisible && (
        <AddUserTaskPopup
          toggleUserTaskPopup={toggleUserTaskPopup}
          auditGroupId={getCurrentSelectedRowData()?.auditGroupId}
          isFromUserTaskList={true}
          isFromMyTaskPage={false}
          isExternalUser={false}
          isManagerView={false}
          attachedLevelId={getCurrentSelectedRowData()?.eaCaseId}
          attachedLevelName={"EAC"}
        ></AddUserTaskPopup>
      )}
      {isReassignProcessManagerPopupVisible && props.isCaseListPage && (
        <ReassignProcessManagerPopup
          selectedRowKeys={selectedCasesList}
        ></ReassignProcessManagerPopup>
      )}
      <BulkUpdatePopup
        selectedEntitiesCountLabel={
          "Cases Selected : " + selectedCasesList?.length
        }
        saveCallbackHandler={bulkEditCasesSaveHandler}
      ></BulkUpdatePopup>
    </div>
  );
};
const caseListBillingIndColumn = (eaCaseNewBillingIndicator, headerCellTemplateFn) => {
    return [
      {
        dataField: "",
        caption: "",
        width: 40,
        alignment: "center",
        allowReordering: false,
        allowExporting: false,
        fixed: true,
        visibleIndex: 1,
        headerCellTemplate: headerCellTemplateFn,
        cellRender: eaCaseNewBillingIndicator,
      },
    ];
};
const caseListEllipsisColumn = (dispatch, toggleCaseListDetailActionPopover, type) =>{
  return([{
      fixed: true,
      alignment: "center",
      dataType: "number",
      visibleIndex: 0,
      visible: type.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE ? false : true,
      cellRender: (e) => {
        if (e.data.eaCaseId == 0) {
          return "";
        } else {
          return getDataGridActionEllipsisComponent(e, {
            showActionPopover: toggleCaseListDetailActionPopover,
            entityName: "eaCase",
            entityId: e.data.eaCaseId,
            currentRowData: e.data,
            type: "usingDispatch",
            dispatch,
          });
        }
      },
      width: 50,
      minWidth: 50,
      maxWidth: 50,
    },
  ])
}
export const caseListCommonColumns = (
  rqstrRecordSubmissionValue,
  hasAuditViewAccess,
  dispatch,
  toggleCaseListDetailActionPopover,
  type
) => {
  return [
    ...caseListEllipsisColumn(dispatch, toggleCaseListDetailActionPopover, type),
    {
      dataField: "patientFullName",
      caption: "Patient Name",
      width: 200,
      alignment: "center",
      cellTemplate: function(container, options) {
        const claimType = options.data.patientFullName;
        const isMatched = options.data.patientNameMatched;
        const cellContent = $("<div>").text(claimType);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "patientAcctNo",
      caption: "Account Number",
      width: 150,
      alignment: "center",
      cellTemplate: function(container, options) {
        const patientAcctNo = options.data.patientAcctNo;
        const isMatched = options.data.patientAcctNoMatched;
        const cellContent = $("<div>").text(patientAcctNo);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "patientAcctNoOrig",
      caption: "Original Account Number",
      width: 150,
      alignment: "center",
      cellTemplate: function(container, options) {
        const patientOrigAcctNo = options.data.patientAcctNoOrig;
        const isMatched = options.data.patientAcctNoOrigMatched;
        const cellContent = $("<div>").text(patientOrigAcctNo);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "patientMRN",
      caption: "MRN",
      width: 100,
      alignment: "center",
      cellTemplate: function(container, options) {
        const patientMRN = options.data.patientMRN;
        const isMatched = options.data.patientMRNMatched;
        const cellContent = $("<div>").text(patientMRN);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "toServiceDate",
      width: 150,
      caption: "Statement To Date",
      alignment: "center",
      cellTemplate: function(container, options) {
        const toServiceDate = options.data.toServiceDate;
        const isMatched = options.data.statementToDateMatched;
        let formattedDate = "";
        if (toServiceDate)
          formattedDate = convertDateFormat(toServiceDate, "MM/DD/YYYY");
        const cellContent = $("<div>").text(formattedDate);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "roundSubmissionDeadline",
      dataType: "date",
      caption: "Round Submission Deadline",
      format: "MM/dd/yyyy",
      alignment: "center",
      width: 150,
    },
    {
      caption: "Current Requester Org",
      dataField: "rqstrOrganizationName",
      width: 200,
      visible: false,
      alignment: "center",
    },
    {
      dataField: "fromServiceDate",
      width: 150,
      caption: "Statement From Date",
      alignment: "center",
      visible: false,
      cellTemplate: function(container, options) {
        const fromServiceDate = options.data.fromServiceDate;
        const isMatched = options.data.statementFromDateMatched;
        let formattedDate = "";
        if (fromServiceDate)
          formattedDate = convertDateFormat(fromServiceDate, "MM/DD/YYYY");
        const cellContent = $("<div>").text(formattedDate);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "caseId",
      width: 150,
      caption: "MDaudit Case ID",
      alignment: "center",
      dataType: "string",
      visible: false,
      cellTemplate: function(container, options) {
        const caseId = options.data.caseId;
        const isMatched = options.data.caseIdMatched;
        const cellContent = $("<div>").text(caseId);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "payerCaseId",
      width: 170,
      caption:
        rqstrRecordSubmissionValue?.toLowerCase() === "perm"
          ? "Payer Case ID"
          : "Payer Claim ID",
      alignment: "center",
      dataType: "string",
      cellTemplate: function(container, options) {
        const isMatched = options.data.caseIdMatched;
        const cellContent = $("<div>").text(options.data.payerCaseId);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "caseStatusCd",
      width: 130,
      caption: "Case Status",
      alignment: "center",
    },
    {
      dataField: "cpTs",
      caption: "CPT/HCPCS",
      allowFiltering: false,
      allowSorting: true,
      allowEditing: false,
      width: 90,
      allowGrouping: false,
      visible: false,
    },
    {
      dataField: "drgDiagCode",
      caption: "DRG",
      width: 100,
      alignment: "center",
      showInColumnChooser: true,
      visible: false,
    },
    {
      dataField: "provider",
      caption: "Provider",
      alignment: "center",
      width: 130,
      calculateDisplayValue: function(rowData) {
        const value = rowData.provider;
        if (
          typeof value === "string" &&
          value.trim() !== "" &&
          !/^,+$/.test(value.trim())
        ) {
          return value;
        }
        return "";
      },
    },
    {
      dataField: "totalClaimChargeAmt",
      caption: "Total Charges",
      width: 130,
      alignment: "right",
    },
    {
      dataField: "totalPaymentAmt",
      caption: "Total Payment Amount",
      width: 150,
      alignment: "right",
    },
    {
      dataField: "atRiskAmt",
      caption: "Total At Risk $",
      width: 130,
      alignment: "right",
      dataType: "number",
      visible: false
    },
    {
      dataField: "reviewRemainingAmnt",
      caption: "Remaining $ in Review",
      width: 130,
      alignment: "right",
      dataType: "number",
      visible: false
    },
    {
      dataField: "totalRetainedAmnt",
      caption: "Total Retained $",
      width: 130,
      alignment: "right",
      dataType: "number",
      visible: false
    },
    {
      dataField: "additionalReimbursementAmnt",
      caption: "Additional Reimbursement",
      width: 130,
      alignment: "right",
      dataType: "number",
      visible: false
    },
    {
      dataField: "refundAmt",
      caption: "Total Refund $",
      width: 130,
      alignment: "right",
      dataType: "number",
      visible: false
    },

    {
      dataField: "previousRoundOutcome",
      caption: "Previous Round Outcome",
      width: 200,
      alignment: "center",
    },
    {
      dataField: "currentRoundOutcome",
      width: 200,
      caption: "Current Round Outcome",
      alignment: "center",
    },
    {
      dataField: "caseFinalOutcome",
      width: 200,
      caption: "Case Final Outcome",
      alignment: "center",
    },
    {
      dataField: "lastRound",
      caption: "Round",
      width: 200,
      alignment: "center",
    },
    {
      dataField: "roundSequenceNo",
      caption: "Round",
      width: 200,
      alignment: "center",
      allowResizing: false,
      allowReordering: false,
      allowExporting: false,
      allowFiltering: false,
      allowSearch: false,
      allowSorting: false,
      visible: false,
    },
    {
      dataField: "claimType",
      caption: "Claim Type",
      width: 130,
      alignment: "center",
      visible: false,
      cellTemplate: function(container, options) {
        const isMatched = options.data.claimTypeCdMatched;
        const cellContent = $("<div>").text(options.data.claimType);
        if (isMatched) {
          cellContent.css("font-weight", "bold");
        }
        cellContent.appendTo(container);
      },
    },
    {
      dataField: "payer",
      caption: "Payer",
      width: 200,
      alignment: "center",
    },
    {
      dataField: "payerGroup",
      caption: "Payer Group",
      width: 200,
      alignment: "center",
      visible: false,
    },
    {
      dataField: "typeOfFacilityCd",
      caption: "Facility",
      width: 100,
      alignment: "center",
      visible: false,
    },
    {
      dataField: "renderingProviderGroup",
      caption: "Rendering Provider Group",
      width: 200,
      alignment: "center",
      visible: false,
    },
    {
      dataField: "documentCount",
      caption: "Documents",
      alignment: "center",
      width: 120,
      visible: hasAuditViewAccess ? true : false,
      cellRender: (cellData) => {
        return (
          <div style={{ cursor: "pointer" }}>
            <u>
              <a
                onClick={() => {
                  toggleCaseDetailPopup(
                    dispatch,
                    true,
                    "Audit Case Details",
                    cellData.data,
                    2
                  );
                }}
              >
                {cellData.data.documentCount}
              </a>
            </u>
          </div>
        );
      },
    },
    {
      dataField: "updatedBy",
      dataType: "string",
      caption: "Updated By",
      alignment: "left",
      width: 150,
      visible: false,
    },
    {
      dataField: "updateDate",
      dataType: "date",
      caption: "Updated On",
      alignment: "left",
      format: "MM/dd/yyyy",
      width: 120,
      visible: false,
    },
    {
      dataField: "manualRefundRequiredInd",
      caption: "Manual Refund Required",
      width: 150,
      visible: false,
    },
    {
      dataField: "refundSubmissionDate",
      dataType: "date",
      caption: "Refund Submitted Date",
      format: "MM/dd/yyyy",
      alignment: "center",
      width: 150,
      visible: false,
    },
    {
      dataField: "refundCompletionDate",
      dataType: "date",
      caption: "Refund Completed Date",
      format: "MM/dd/yyyy",
      alignment: "center",
      width: 150,
      visible: false,
    },
    {
      caption: "Incomplete Task Count",
      dataField: "inCompleteTaskCount",
      alignment: "center",
      width: 120,
      cellRender: (cellData) => {
        if (cellData.data.inCompleteTaskCount > 0) {
          return (
            <div style={{ cursor: "pointer" }}>
              <u>
                <a
                  onClick={() => {
                    toggleCaseDetailPopup(
                      dispatch,
                      true,
                      "Audit Case Details",
                      cellData.data,
                      1
                    );
                    dispatch({
                      type: SET_IS_INCOMPLETE_TASK_COUNT_CLICK,
                      isInCompleteTaskCountClick: [
                        cellData.data.eaCaseId,
                        true,
                      ],
                    });
                  }}
                >
                  {cellData.data.inCompleteTaskCount}
                </a>
              </u>
            </div>
          );
        }
      },
      visible: false,
    },
    {
      dataField: "roundStartDate",
      dataType: "date",
      caption: "Round Start Date",
      format: "MM/dd/yyyy",
      alignment: "center",
      width: 150,
      visible: false,
    },
    {
      dataField: "actualSubmissionDate",
      dataType: "date",
      caption: "Actual Submission Date",
      format: "MM/dd/yyyy",
      alignment: "center",
      width: 150,
      visible: false,
    },
    {
      dataField: "roundDeterminationDate",
      dataType: "date",
      caption: "Round Determination Date",
      format: "MM/dd/yyyy",
      alignment: "center",
      width: 150,
      visible: false,
    },
    {
      dataField: "currentContentType",
      caption: "Current Content Type",
      width: 100,
      visible: false,
      alignment: "right",
    },
    {
      dataField: "altEaCaseId",
      width: 150,
      caption: "Alt Case ID",
      alignment: "center",
      dataType: "string",
      visible: false,
    },
    {
      dataField: "altEaRoundCaseId",
      width: 150,
      caption: "Current Round Case ID",
      alignment: "center",
      dataType: "string",
      visible: false,
    },
    {
      dataField: "denialReasonName",
      width: 150,
      caption: "Denial Reason",
      alignment: "center",
      dataType: "string",
    },
  ] as IColumnProps[];
};

export const caseListPageColumns = (
  dispatch,
  toggleCaseListDetailActionPopover,
  eaCaseNewBillingIndicator,
  rqstrRecordSubmissionValue,
  headerBillingDataIndicator
) => {
  return [
    ...caseListEllipsisColumn(dispatch, toggleCaseListDetailActionPopover, ""),
    ...caseListBillingIndColumn( eaCaseNewBillingIndicator,headerBillingDataIndicator),

    {
      caption: "Patient Name",
      dataField: "patientFullName",
      width: 200,
      fixed: true,
      dataType: "string",
      allowSearch: true
    },
    {
      caption: rqstrRecordSubmissionValue?.toLowerCase() === "perm"
          ? "Payer Case ID"
          : "Payer Claim ID",
      dataField: "payerCaseId",
      width: 150,
      dataType: "string",
      allowSearch: true
    },
    {
      caption: "Original Account Number",
      dataField: "patientAcctNoOrig",
      width: 150,
      dataType: "string",
      allowSearch: true
    },
    {
      caption: "MRN",
      dataField: "patientMRN",
      width: 100,
      dataType: "string",
      allowSearch: true
    },
    {
      caption: "Requester - Current",
      dataField: "rqstrOrganizationName",
      width: 150,
      dataType: "string",
      allowSearch: false
    },
      {
      caption: "Notification Date",
      dataField: "auditNotificationDate",
      width: 100,
      dataType: "date",
      format: "MM/dd/yyyy",
      allowSearch: false
    },
    {
      dataField: "caseStatusCd",
      width: 130,
      caption: "Case Status",
      alignment: "center",
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "totalClaimChargeAmt",
      caption: "Total Charges",
      width: 130,
      alignment: "right",
      dataType: "number",
      allowSearch: false
    },
    {
      dataField: "totalPaymentAmt",
      caption: "Total Payment Amount",
      width: 150,
      alignment: "right",
      dataType: "number",
      allowSearch: false
    },
    {
      dataField: "atRiskAmt",
      caption: "Total At Risk $",
      width: 130,
      visible: false,
      alignment: "right",
      dataType: "number",
      allowSearch: false
    },
    {
      dataField: "reviewRemainingAmnt",
      caption: "Remaining $ in Review",
      width: 130,
      visible: false,
      alignment: "right",
      dataType: "number",
      allowSearch: false
    },
    {
      dataField: "totalRetainedAmnt",
      caption: "Total Retained $",
      width: 130,
      visible: false,
      alignment: "right",
      dataType: "number",
      allowSearch: false
    },
    {
      dataField: "additionalReimbursementAmnt",
      caption: "Additional Reimbursement",
      width: 130,
      visible: false,
      alignment: "right",
      dataType: "number",
      allowSearch: false
    },
    {
      dataField: "refundAmt",
      caption: "Total Refund $",
      width: 130,
      visible: false,
      alignment: "right",
      dataType: "number",
      allowSearch: false
    },
    {
      caption: "Current Round Submission Deadline",
      dataField: "roundSubmissionDeadline",
      width: 100,
      dataType: "date",
      format: "MM/dd/yyyy",
      allowSearch: false
    },
    {
      caption: "Case Process Manager",
      dataField: "caseProcessManagerName",
      width: 150,
      dataType: "string",
      allowSearch: false,
    },
    {
      caption: "Audit Process Manager",
      dataField: "processManagerName",
      width: 150,
      dataType: "string",
      allowSearch: false,
      visible:false
    },
    {
      caption: "Audit Title",
      dataField: "auditTitle",
      width: 300,
      fixed: true,
      dataType: "string",
      allowSearch: true
    },
    {
      caption: "Audit ID",
      dataField: "eaAuditId",
      width: 90,
      dataType: "string",
      cellRender: ({ data }) => {
        return (
          <>
            <a
              href={"/externalaudit/audit?auditId=" + data.eaAuditId}
              target="_blank"
            >
              {data.eaAuditId}
            </a>
          </>
        );
      },
      allowSearch: false
    },
    {
      dataField: "patientAlternateMRN",
      caption: "Alternate MRN",
      width: 150,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "patientAcctNo",
      caption: "Account Number",
      width: 150,
      visible: false,
      dataType: "string",
      allowSearch: true
    },
    {
      dataField: "toServiceDate",
      width: 150,
      caption: "Statement To Date",
      visible: false,
      dataType: "date",
      format: "MM/dd/yyyy",
      allowSearch: false
    },
    {
      dataField: "provider",
      caption: "Provider",
      width: 130,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "previousRoundOutcome",
      caption: "Previous Round Outcome",
      width: 200,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "currentRoundOutcome",
      width: 200,
      caption: "Current Round Outcome",
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "caseFinalOutcome",
      width: 200,
      caption: "Case Final Outcome",
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "payer",
      caption: "Payer",
      width: 200,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "denialReasonName",
      width: 150,
      caption: "Denial Reason",
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "actualSubmissionDate",
      dataType: "date",
      caption: "Actual Submission Date",
      format: "MM/dd/yyyy",
      width: 150,
      visible: false,
      allowSearch: false
    },
    {
      dataField: "altEaCaseId",
      width: 150,
      caption: "Alt Case ID",
      alignment: "center",
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "cpTs",
      caption: "CPT/HCPCS",
      width: 90,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "currentContentType",
      caption: "Current Content Type",
      width: 100,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "documentCount",
      caption: "Documents",
      allowSearch: false,
      width: 120,
      visible: false,
      cellRender: (cellData) => {
        return (
          <div style={{ cursor: "pointer" }}>
            <u>
              <a
                onClick={() => {
                  toggleCaseDetailPopup(
                    dispatch,
                    true,
                    "Audit Case Details",
                    cellData.data,
                    2
                  );
                }}
              >
                {cellData.data.documentCount}
              </a>
            </u>
          </div>
        );
      },
      dataType: "number",
    },
    {
      dataField: "drgDiagCode",
      caption: "DRG",
      width: 100,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "typeOfFacilityCd",
      caption: "Facility",
      width: 100,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      caption: "Incomplete Task Count",
      dataField: "inCompleteTaskCount",
      dataType: "number",
      width: 120,
      cellRender: (cellData) => {
        if (cellData.data.inCompleteTaskCount > 0) {
          return (
            <div style={{ cursor: "pointer" }}>
              <u>
                <a
                  onClick={() => {
                    toggleCaseDetailPopup(
                      dispatch,
                      true,
                      "Audit Case Details",
                      cellData.data,
                      1
                    );
                    dispatch({
                      type: SET_IS_INCOMPLETE_TASK_COUNT_CLICK,
                      isInCompleteTaskCountClick: [
                        cellData.data.eaCaseId,
                        true,
                      ],
                    });
                  }}
                >
                  {cellData.data.inCompleteTaskCount}
                </a>
              </u>
            </div>
          );
        }
      },
      visible: false,
      allowSearch: false
    },
    {
      dataField: "manualRefundRequiredInd",
      caption: "Manual Refund Required",
      width: 150,
      visible: false,
      dataType: "boolean",
      allowSearch: false
    },
    {
      dataField: "caseId",
      width: 150,
      caption: "MDaudit Case ID",
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "payerGroup",
      caption: "Payer Group",
      width: 200,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "refundCompletionDate",
      dataType: "date",
      caption: "Refund Completed Date",
      format: "MM/dd/yyyy",
      width: 150,
      visible: false,
      allowSearch: false
    },
    {
      dataField: "renderingProviderGroup",
      caption: "Rendering Provider Group",
      width: 200,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
      {
      dataField: "roundDeterminationDate",
      dataType: "date",
      caption: "Round Determination Date",
      format: "MM/dd/yyyy",
      width: 150,
      visible: false,
      allowSearch: false
    },
    {
      dataField: "roundStartDate",
      dataType: "date",
      caption: "Round Start Date",
      format: "MM/dd/yyyy",
      width: 150,
      visible: false,
      allowSearch: false
    },
    {
      dataField: "fromServiceDate",
      width: 150,
      caption: "Statement From Date",
      visible: false,
      dataType: "date",
      format: "MM/dd/yyyy",
      allowSearch: false
    },
    {
      caption: "Audit group",
      dataField: "auditGroupName",
      width: 200,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      caption: "Claim Type",
      dataField: "claimType",
      width: 110,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      caption: "Overdue Task",
      width: 100,
      dataField: "overdueTaskCount",
      visible: false,
      dataType: "number",
      allowSearch: false
    },
    {
      caption: "Process Template",
      dataField: "eaProcessTemplateName",
      width: 150,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      caption: "Source",
      dataField: "eaSourceName",
      width: 100,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
     {
      caption: "Reference Number",
      dataField: "auditReferenceId",
      width: 100,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      caption: "Requester - Initial",
      dataField: "requesterOrganizationNameInitial",
      width: 150,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      caption: "Audit Period",
      dataField: "auditPeriodName",
      width: 100,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
     {
      dataField: "updatedBy",
      caption: "Updated By",
      width: 100,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "updateDate",
      caption: "Updated On",
      width: 100,
      dataType: "date",
      format: "MM/dd/yyyy",
      visible: false,
      allowSearch: false
    },
    {
      dataField: "createdBy",
      caption: "Created By",
      width: 100,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "createDate",
      caption: "Created On",
      width: 100,
      dataType: "date",
      format: "MM/dd/yyyy",
      visible: false,
      allowSearch: false
    },
    {
      caption: "AuditCaseEntryTypeCd",
      dataField: "auditCaseEntryTypeCd",
      width: 200,
      visible: false,
      dataType: "string",
      allowSearch: false
    },
    {
      caption: "Status",
      dataField: "auditStatus",
      width: 100,
      dataType: "string",
      allowSearch: false
    },
    {
      dataField: "payerRemitNo",
      caption: "Payer Remit #",
      width: 150,
      visible: false,
      dataType: "string",
      allowSearch: true
    },
  ] as IMdaeDataGridColumnProps[];
};


export const caseDetailDataGridLocalStorageKeyName = "ea-case-list-storage-key-2";
export const caseDetailDataGridLocalStorageKeyNameForCaseListPage = "ea-case-list-storage-key-for-case-list-page";
export const caseDetailDataGridLocalStorageKeyNameForMyCasesPage = "ea-my-cases-list-storage-key";
export const emdrCaseDetailDataGridLocalStorageKeyName = "emdr-ea-case-list-storage-key-2";
export const getCaseListDetailDataGridOptions = (
  toggleCaseListDetailActionPopover,
  eaCaseListDataSource,
  caseListRowPrepared,
  eaAuditId,
  setCaseDetailDataGridInstance,
  dispatch,
  hasAuditViewAccess,
  currentUserActionMode,
  hasHospitalWorkFlowEnabled,
  hasProfessionalWorkFlowEnabled,
  eaAuditRounds,
  onCaseListDetailDataGridContentReady,
  toggleCaseDetailPopup,
  eaCaseNewBillingIndicator,
  showGrouping,
  caseListType,
  headerBillingDataIndicator,
  myCases
) => {
  var groupPanelConfig = {
    visible: showGrouping ? false : true,
  };
  if (caseListType === CASE_LIST_TYPES.FROM_CASE_LIST_PAGE) {
    groupPanelConfig = {
      visible: true,
    };
  }
  const caseListDetailDataGridOption: IMdaeDataGridProps = {
    id: "pnlCaseListDetailGrid",
    className: "case-list-detail-grid-container",
    clearFilterButtonId: "btn-case-list-detail-grid-clear-filter",
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    mdaeSearchPanel: { visible: true, searchVisibleColumnsOnly: true },
    loadPanel: {
      enabled: caseListType === CASE_LIST_TYPES.FROM_CASE_LIST_PAGE,
    },
    export: {
      enabled: true,
      fileName: myCases ? "ExternalCaseList" : "External_Audit_" + eaAuditId + "_Case_List",
    },
    onInitialized: (e) => {
      setCaseDetailDataGridInstance(e.component);
    },
    onRowDblClick: (e) => {
      if (e?.rowType === "data")
        toggleCaseDetailPopup(dispatch, true, "Audit Case Details", e.data, 0);
    },
    onSelectionChanged: (e) => {
      if (currentUserActionMode == USER_ACTION_MODE.BULK_UPDATE) {
        var disabledSelectionRows = e.selectedRowsData?.filter(
          (x) => x.statusType?.toLowerCase() === "completed"
        );
        if (disabledSelectionRows && disabledSelectionRows.length) {
          e.component.deselectRows(
            disabledSelectionRows.map((x) => x.eaCaseId)
          );
        }
      }
      if (currentUserActionMode == USER_ACTION_MODE.ADD_TO_INTERNAL_AUDIT) {
        var removeSelectionRows = e.selectedRowsData?.filter(
          (x) =>
            (x.claimType.toLowerCase() === "professional" &&
              !hasProfessionalWorkFlowEnabled) ||
            (x.claimType.toLowerCase() === "hospital" &&
              !hasHospitalWorkFlowEnabled)
        );
        if (removeSelectionRows && removeSelectionRows.length) {
          e.component.deselectRows(removeSelectionRows.map((x) => x.eaCaseId));
        }
      }
    },
    allowColumnResizing: true,
    allowColumnReordering: true,
    filterRow: { visible: true },
    headerFilter: { visible: true },
    groupPanel: groupPanelConfig,
    grouping: {
      autoExpandAll: true,
    },
    mdaeStateStoring: {
      enabled: true,
      storageKey:
        caseListType === CASE_LIST_TYPES.FROM_CASE_LIST_PAGE
        ? (myCases
            ? caseDetailDataGridLocalStorageKeyNameForMyCasesPage
            : caseDetailDataGridLocalStorageKeyNameForCaseListPage)
        : caseDetailDataGridLocalStorageKeyName,
      onBeforeLoadGridState(layoutData) {
        if (layoutData) {
          if (layoutData.columns) layoutData.columns[1].visible = true;
          delete layoutData.selectedRowKeys;
          if (layoutData?.pageSize == null || layoutData?.pageSize === 0) {
            layoutData.pageSize = 10;
          }
        }
      },
    },
    dataSource: eaCaseListDataSource,
    remoteOperations: caseListType === CASE_LIST_TYPES.FROM_CASE_LIST_PAGE,
    onContentReady:
      caseListType === CASE_LIST_TYPES.FROM_AUDIT
        ? onCaseListDetailDataGridContentReady
        : null,
    onCellPrepared: caseListRowPrepared,
    keyExpr: "eaCaseId",

    mdaeColumns: [
      ...(caseListType === CASE_LIST_TYPES.FROM_CASE_LIST_PAGE
        ? caseListPageColumns(
            dispatch,
            toggleCaseListDetailActionPopover,
            eaCaseNewBillingIndicator,
            eaAuditRounds[0]?.rqstrRecordSubmissionValue,
            headerBillingDataIndicator
        )
        : [
            ... caseListBillingIndColumn(eaCaseNewBillingIndicator,headerBillingDataIndicator),
            ...caseListCommonColumns(
              eaAuditRounds[0]?.rqstrRecordSubmissionValue,
              hasAuditViewAccess,
              dispatch,
              toggleCaseListDetailActionPopover,
              "List"
            ),
          ]),
    ],
  };
  return caseListDetailDataGridOption;
};
const enhance = compose(withRouter);

export default enhance(CaseListDetail);
